<template>
  <div class="data-block" :style="block.style">
    <h3 contenteditable="true" @blur="updateTitle">{{ block.data.title }}</h3>
    <div class="data-fields">
      <div
        v-for="(field, index) in block.data.fields"
        :key="index"
        class="data-field"
      >
        <label contenteditable="true" @blur="updateFieldLabel(index, $event)">
          {{ field.label }}
        </label>
        <input
          :value="field.value"
          @input="updateFieldValue(index, $event)"
          class="data-input"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  block: any;
  pageIndex: number;
  blockIndex: number;
}>();

const emit = defineEmits<{
  update: [data: any];
  contentEdit: [];
}>();

function updateTitle(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { title: target.innerText });
  emit("contentEdit");
}

function updateFieldLabel(index: number, event: Event) {
  const target = event.target as HTMLElement;
  const newFields = [...props.block.data.fields];
  newFields[index].label = target.innerText;
  emit("update", { fields: newFields });
  emit("contentEdit");
}

function updateFieldValue(index: number, event: Event) {
  const target = event.target as HTMLInputElement;
  const newFields = [...props.block.data.fields];
  newFields[index].value = target.value;
  emit("update", { fields: newFields });
  emit("contentEdit");
}
</script>

<style scoped>
.data-block {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
}

.data-block h3 {
  margin: 0 0 15px 0;
  color: #333;

  &:focus {
    outline: 2px dashed #007bff;
  }
}

.data-fields {
  display: grid;
  gap: 12px;
}

.data-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f8f9fa;
}

.data-field label {
  font-weight: bold;
  color: #555;
  min-width: 150px;

  &:focus {
    outline: 2px dashed #007bff;
  }
}

.data-input {
  border: 1px dashed #ccc;
  padding: 6px 10px;
  border-radius: 4px;
  min-width: 200px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
}
</style>
